<template>
  <div class="schoolprofile">
    <div class="content">
      <h1>在线选课</h1>
      <div class="clearfix"></div>

      <div class="divTab">
        <div class="personalinfo">
          姓名：<span>{{ userInfo.name }}</span> 专业层次：<span>{{
            userInfo.learnLevel
          }}</span
          >专业：<span>{{ userInfo.proName }}</span
          >年级：<span>{{ userInfo.grade }}级</span>学号：<span>{{
            userInfo.studentNo
          }}</span>
        </div>
        <div class="tips">
          1.本学期只有一次选课机会<br />
          2.选修课选课时间：
          <span v-if="selectCourseConfig.studentStartDate && selectCourseConfig.studentEndDate">
            {{ selectCourseConfig.studentStartDate }}至{{ selectCourseConfig.studentEndDate }}
          </span>
          <span v-else>暂未设置选课时间</span>
          <br />
          3.取消已选课程，成绩将会清零<br />
        </div>
        <div class="clearfix"></div>
        <table class="table table-bordered" style="width: 100%">
          <tr>
            <td class="infobg" width="10%">学年学期</td>
            <td class="infobg" width="8%">课程类型</td>
            <td class="infobg" width="20%">课程名称</td>
            <td class="infobg" width="6%">学分</td>
<!--            <td class="infobg" width="12%">网络学习 /网络考试</td>
            <td class="infobg" width="12%">网络考试 起止时间</td>-->
            <td class="infobg" width="8%">网学/网考</td>
            <td class="infobg" width="8%">考核方式</td>
            <td class="infobg" width="8%">初次选课</td>
            <td class="infobg" width="8%">重修选课</td>
            <td class="infobg" width="8%">课程状态</td>
          </tr>
          <tr
            v-for="(tab, index) in tableData"
            :key="index"
            :style="{ backgroundColor: getRowColor(tab.layoutTermOrder) }"
          >
            <td>{{ `${tab.layoutYear} ${tab.layoutTermName}` }}</td>
            <td>{{ tab.courseType }}</td>
            <td>{{ tab.viewName }}</td>
            <td>{{ tab.planLessonPeriod }}</td>
<!--            <td>{{ tab.web }}</td>
            <td>{{ tab.time }}</td>-->
            <td>
              <span v-if="tab.webLearnFlag == 1">是</span><span v-if="tab.webLearnFlag == 0">否</span>/
              <span v-if="tab.isWebTestFlag == 1">是</span><span v-if="tab.isWebTestFlag == 0">否</span>
            </td>
            <td>{{ tab.checkMethod }}</td>
<!--            @change="checkBoxChange(index)"-->
            <td>
              <a-checkbox
                  :disabled="!tab.isCanSelect || tab.isFirst != 1 || tab.courseType != '选修课' || tab.layoutTermOrder > selectCourseConfig.layoutTermOrder"
                  v-model="tableData[index].oneCheck"
                  @change="checkBoxChange(1,index)"
              >
                初选
              </a-checkbox>
            </td>
            <td>
              <a-checkbox
                  :disabled="!tab.isCanSelect || tab.isFirst == 1 || tab.courseType != '选修课' || tab.layoutTermOrder > selectCourseConfig.layoutTermOrder"
                  v-model="tableData[index].twoCheck"
                  @change="checkBoxChange(2,index)"
              >
                重修
              </a-checkbox>
            </td>
            <td>
              <div v-if="null == tab.isSelect || !tab.isSelect">
              </div>
              <div v-else-if="null != tab.lessonPeriod && tab.lessonPeriod > 0">
                通过
              </div>
              <div v-else-if="tab.courseStatus == 1">
                在修
              </div>
              <div v-else>
                未通过
              </div>
            </td>
          </tr>
        </table>
        <div class="selectcoursedes">
          已修学分：<span>{{lessonPeriod}}</span>
          ，可修学分<span>{{remainingLessonPeriod}}</span>，当前选择学分<span>{{keepOneDecimal(selectLessonPeriod - lessonPeriod)}}</span>
        </div>
        <div class="explain">
          <strong>在线选课说明：</strong><br />
          1.必修课已由系统按开课学期默认选课，不需要学生个人选课。<br />
          2.选修课由学生个人按各学期开出的课程进行选课，但当前对选修课的选课门数限定在达到{{selectCourseConfig.bigLessonPeriod}}分的最少门数内。<br />
          3.当前学期可以对此前未选过的课程按【初次选课】进行选课，对此前已选过但考试未通过的课程（含必修课和选修课）按【重修选课】进行选课重修<br />
        </div>
        <div class="confirm">
          <button class="btn btn-info" @click="handeleSubmit">确认选课</button>
        </div>
      </div>
    </div>
    <a-modal v-model:open="openModal" title="确认选课" :footer="null" class="custom-select-course-modal" style="height: 500px">
      <div style="height: 100px;position: relative">
        <p>是否确认提交?
          (注:新被选上的课程请从【我的课程】当前学期在线学习和考试，取消的课程已取得的平时成绩会清零，并退出【我的课程】当前学期)</p>
        <div style="position: absolute; right: 10px; bottom: 0px;">
          <button class="btn btn-info" @click="modalHandleOk" :disabled="isLoading">{{ isLoading ? '提交中...' : '确认' }}</button>
          <button class="btn btn-default" @click="modalHandleCancel">取消</button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CourseList",
  props: {},
  data: function () {
    return {
      tableBgArray: ["", "#efebe2", "#f6e1b5", "#c9eadd"],
      tableData: [

      ],
      selectCourseConfig: {},
      lessonPeriod: 0,
      remainingLessonPeriod: 0,
      selectLessonPeriod: 0,
      isLoading: false,
      layoutTermOrder: 0,
      openModal: false
    };
  },
  methods: {
    checkBoxChange: function (code, i) {
      const changeData = this.tableData[i]
      if(this.remainingLessonPeriod == 0 ||(changeData.oneCheck || changeData.twoCheck) && (this.selectLessonPeriod - this.lessonPeriod) >= this.remainingLessonPeriod){
        changeData.oneCheck = false
        changeData.twoCheck = false
        this.$message.warn('你当前【选修课】的学分已达到' + this.selectCourseConfig.bigLessonPeriod + '分' )
      }else{
        if(changeData.courseType == '选修课'){
          if(changeData.oneCheck || changeData.twoCheck){
            this.selectLessonPeriod += changeData.planLessonPeriod
          }
          if(!changeData.oneCheck && !changeData.twoCheck){
            this.selectLessonPeriod = this.selectLessonPeriod - changeData.planLessonPeriod
          }
        }
        if(code == 1){
          if(changeData.oneCheck){
            changeData.status = '1'
          }else{
            changeData.status = '0'
          }
        }else if(code == 2){
          if(changeData.twoCheck){
            changeData.status = '1'
          }else{
            changeData.status = '0'
          }
        }
      }
    },
    // 获取选课配置
    getCourseConfig: function () {
      this.axios.get("stuSelectCourse/querySelectConfig").then((res) => {
        console.log("获取选课配置", res); // 先查看控制台，确认 res.result 的结构

        // 1. 确认 res.result 是对象（而非数组），直接赋值给 selectCourseConfig
        this.selectCourseConfig = res.result || {}; // 避免 null/undefined 导致后续报错

        // 2. 提取配置中的 lessonPeriod（已修学分），赋值给对应的变量
        if (this.selectCourseConfig.lessonPeriod !== undefined && this.selectCourseConfig.lessonPeriod !== null) {
          this.lessonPeriod = this.selectCourseConfig.lessonPeriod;
          this.remainingLessonPeriod = this.selectCourseConfig.bigLessonPeriod - this.lessonPeriod
          if(this.remainingLessonPeriod < 0){
            this.remainingLessonPeriod = 0
          }
        }
        //获取当前学期
        this.layoutTermOrder = res.result.layoutTermOrder
        // 3. （关键）tableData 仍需通过「课程列表接口」获取（数组），不要用配置接口的结果赋值
        // 若需同时获取配置和课程列表，可在配置接口成功后调用课程列表接口
        // this.getCourseList();
      });
    },
    // 获取课程列表
    getCourseList: function () {
      this.axios.get("stuSelectCourse/queryAllCourseList").then((res) => {
        if (Array.isArray(res.result)) {
          // 关键：用 map 返回新对象，所有项都初始化 oneCheck
          res.result.forEach((item) =>{
            if(null != item.isSelect && item.isSelect){
              item.oneCheck = item.oneCheck
              item.twoCheck = item.twoCheck
              if((item.oneCheck || item.twoCheck) && item.courseType == '选修课'){
                console.log(item.planLessonPeriod)
                this.selectLessonPeriod += item.planLessonPeriod
              }
            }else{
              item.oneCheck = false
              item.twoCheck = false
            }
            this.tableData.push(item)
          })
          console.log(this.selectLessonPeriod)
         /* this.tableData = res.result.map(item => {

           /!* return {
              ...item,
              // 初始化 oneCheck：默认未选中，符合条件则选中
              oneCheck: item.isCanSelect && item.isSelect && item.isFirst == 1,
              twoCheck: item.isCanSelect && item.isSelect && item.isFirst != 1
            };*!/
          });*/
        } else {
          this.tableData = [];
        }
      });
    },
    batchSelect: function (){
      /*this.tableData.forEach((x) => {
        x.scoreId = x.id
      })*/
      this.axios.post("stuSelectCourse/batchSelect",this.tableData).then((res) => {
        this.$message.success("提交成功！");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }).finally(() => {
        this.isLoading = false; // 请求完成（无论成功/失败）后关闭加载状态
        this.openModal = false
      });
    },
    handeleSubmit: function () {
      this.openModal = true
    },
    modalHandleOk: function (){
      this.isLoading = true
      this.tableData.forEach((x) => {
        if(x.oneCheck){
          x.isFirst = '1'
          x.status = '1'
        }
        if(x.twoCheck){
          x.status = '1'
        }
      })
      this.batchSelect()
    },
    modalHandleCancel: function (){
      this.openModal = false
    },
    keepOneDecimal :function (value) {
      if (isNaN(value)) return '0.0';
      let selectSum = Number(value).toFixed(1);
      if(selectSum < 0){
        return 0
      }
      return selectSum
    },
    getRowColor(val) {
      if(val < this.selectCourseConfig.layoutTermOrder){
        return '#efebe2';
      }else if(val == this.selectCourseConfig.layoutTermOrder){
        return '#f6e1b5';
      }
      return '#c9eadd';
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getCourseConfig();
    this.getCourseList();
  },
  mounted() {

  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.schoolprofile {
  margin-bottom: 30px;

  .content {
    width: $pageWidth;
    margin: 0 auto;

    .choose {
      text-align: center;
    }

    h1 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;

      .english {
        color: #999;
        font-size: 14px;
        font-weight: normal;
        text-transform: Uppercase;
      }
    }
  }

  .course {
    margin-bottom: 30px;
    padding: 28px;
    background: #f8fefc;
    width: 100%;

    &:hover {
      box-shadow: 0px 0px 10px #999;
    }

    a {
      color: #333;

      & .course-des {
        color: $fontGray;
      }
    }

    .course-img {
      img {
        width: 176px;
        height: 100px;
      }
    }

    .course-title {
      font-size: 18px;
      line-height: 20px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }

    .course-des {
      margin-top: 10px;
      line-height: 20px;
      color: #999;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .choose {
    width: 300px;
    margin: 0 auto;

    .btn {
      width: 90px;
      border: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.choose li {
  float: left;
}

.btn:focus, .btn.focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.more {
  font-size: 14px;
  font-weight: normal;

  &:hover {
    text-decoration: none;
  }
}

a.more {
  color: #999;
}

.divTab {
  background: #fff;
  padding: 28px;
}

.course {
  margin-bottom: 20px;
}

.course-detail {
  color: #999;
  margin-bottom: 6px;

  .course-score {
    font-size: 18px;
    font-weight: bold;
    color: $bgColor;
  }
}

.buttons {
  margin-top: 20px;
}

.examinationtime {
  color: #999;
}

.course-btn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 92px;
  height: 30px;
  background: #ccd1cf;
  line-height: 30px;
  border-radius: 15px;
  color: #fff;
  border: none;
  margin-top: 20px;
  margin-bottom: 20px;
}

.examinationtime p {
  margin-bottom: 10px;
}

.table {
  margin-bottom: 0px;

  .titles {
    font-weight: bold;
    text-align: left;
  }

  td {
    text-align: center;
  }

  .infobg {
    background: $navigationBgColor;
    font-weight: bold;
    color: #ffffff;
  }

  .scores {
    text-decoration: underline;
    color: $bgColor;
    cursor: pointer;
  }
}

.tips {
  background: $bgcontent;
  border: 1px solid #efefef;
  margin-bottom: 20px;
  padding: 15px 20px;
  line-height: 26px;
}

.selectcoursedes {
  background: $bgcontent;
  border: 1px solid #efefef;
  margin-bottom: 20px;
  padding: 15px 20px;

  span {
    color: $bgColor;
    font-weight: bold;
  }
}

.chooses {
  border-bottom: 1px solid #ededed;
  margin-bottom: 20px;

  li {
    float: left;
    padding: 0 15px;
    padding-bottom: 8px;
    font-weight: bold;
  }
}

.active {
  color: $bgColor;
  border-bottom: 2px solid $bgColor;
  padding-bottom: 8px;
}

.kcimg {
  img {
    width: 146px;
    height: 84px;
  }
}

.class_a {
  background: $bgColor;
  border: $bgColor;
}

.class_b {
  background: #efefef;
  color: #9c9999;
  border: 1px solid #efefef;
}

.btn-info {
  background: $bgColor !important;
  border: 1px solid $bgColor;

  &.active {
    background: #ced1d5 !important;
    border: 1px solid #ced1d5 !important;
  }
}

.confirm {
  margin-top: 20px;
  text-align: center;

  .btn {
    padding: 6px 16px;
    background: #efefef;
  }
}

.personalinfo {
  font-size: 16px;
  margin-bottom: 20px;
  background: $bgColor;
  color: #fff;
  padding: 12px 20px;

  span {
    font-weight: bold;
    margin-right: 25px;
  }
}

.icon-tongguo {
  color: $bgColor;
}

.explain {
  background: #f6fffb; /* 内页背景颜色 */
  border: 1px solid #efefef;
  margin-bottom: 20px;
  line-height: 32px;
  padding: 15px 20px;
  color: #666;

  strong {
    font-weight: bold;
    color: #333;
  }
}

.table th, .table td {
  vertical-align: middle;
}

.btn {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/courseselection/components/CourseList.vue